import { useReactiveVar } from '@apollo/client';
import { ThemeProvider } from '@fluentui/react';
import React, { PropsWithChildren } from 'react';
import { darkTheme } from 'theme/dark';
import { lightTheme } from 'theme/light';
import { darkMode } from 'utility/cache/ui';

const FluentUITheme: React.FC<PropsWithChildren> = ({ children }) => {
  const useDark = useReactiveVar(darkMode);

  return (
    <ThemeProvider applyTo="body" theme={useDark ? darkTheme : lightTheme}>
      {children}
    </ThemeProvider>
  );
};

export default FluentUITheme;
